// Curated Unsplash imagery for an artisanal plastering / interior atelier.
// Each URL uses Unsplash CDN parameters for resolution control.
const u = (id, w = 1600) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMG = {
  // Hero / large editorial
  hero: u("photo-1615873968403-89e068629265", 2000),       // warm minimal interior, textured wall
  heroAlt: u("photo-1618219740975-d40978bb7378", 2000),     // plaster wall close-up
  // Services
  servicePlaster: u("photo-1591105575633-922c360b1f7f", 1200),     // plastering hands
  serviceStucco: u("photo-1618220252344-8ec99ec624b1", 1200),       // venetian stucco texture
  serviceRestoration: u("photo-1600585154340-be6161a56a0c", 1200),  // restored interior
  serviceSmoothing: u("photo-1556909114-f6e7ad7d3136", 1200),       // refined living room
  serviceRepair: u("photo-1493809842364-78817add7ffb", 1200),       // wall detail
  serviceCustom: u("photo-1583847268964-b28dc8f51f92", 1200),       // decorative finish
  // About / craft
  craftHands: u("photo-1581094271901-8022df4466f9", 1400),          // craftsman with trowel
  craftTexture: u("photo-1604147495798-57beb5d6af73", 1400),        // textured wall
  founderPortrait: u("photo-1507003211169-0a1dd7228f2d", 900),      // portrait silhouette
  team: u("photo-1521791136064-7986c2920216", 1400),                // hands working
  // Interiors
  livingRoom: u("photo-1505693416388-ac5ce068fe85", 1600),
  warmHallway: u("photo-1493809842364-78817add7ffb", 1400),
  bedroom: u("photo-1560448204-e02f11c3d0e2", 1400),
  // Texture / accents
  warmWall: u("photo-1503602642458-232111445657", 1400),
  marble: u("photo-1604147495798-57beb5d6af73", 1200),
};

export default IMG;
